export const calcLocalStorageInfoName = (accountId: string, roomId: string, sessionId: string) => {
  return `${accountId}-${roomId}-${sessionId}-voice-memo-meeting`
}

export const generateChunkName = (roomId: string, sessionId: string, sequence: string) => {
  return `${roomId}_${sessionId}_${sequence.padStart(10, '0')}`
}
